import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareProofupQuery } from "src/shared/config/storeConfig";

export const proofupApi = createApi({
  reducerPath: "proofupApi",
  baseQuery: prepareProofupQuery(),
  endpoints: (builder) => ({
    getProofupUrl: builder.mutation({
      query: (body) => ({
        url: `/application/application/link`,
        method: "POST",
        body,
      }),
    }),
    getProofupProperty: builder.mutation({
      query: (id) => ({
        url: `/property/property/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetProofupUrlMutation, useGetProofupPropertyMutation } =
  proofupApi;
